<template>
  <div>
    <TheLayout>
    <div v-if="dataPermission && dataPermission.includes('NSH_PARTNER_CUS_VIEW')">
      <div id="layout-wrapper">
        <header id="page-topbar">
          <div class="navbar-header headerPage">
            <div>
              <BaseButton variant="secondary" @click="$router.push(`/customer-list`)">Quay lại</BaseButton>
            </div>
            <div class="headerPage-title"><p>Chi tiết khách hàng</p></div>
            <div class="headerPage-button">
              <button class="btn btn-danger-ext"
              v-if="dataPermission && dataPermission.includes('NSH_PARTNER_CUS_DELETE')"
              @click="deleteItem(dataCustomer)">Xóa khách hàng</button>
            </div>
          </div>
        </header>
        <div class="container-fluid">
          <div class="layout-content">
            <LayoutCard>
              <div class="box-title">Thông tin cá nhân
                <span class="text-primary mb-0 pull-right btn btn-default btn-default-edit" v-if=" dataPermission && dataPermission.includes('NSH_PARTNER_CUS_UPDATE')" @click="editItem()">Chỉnh sửa</span>
              </div>
              <div class="box-content">
                <div class="createStoreForm">
                  <div class="row">
                    <div class="col-md-6">
                      <b-form-group>
                          <div class="row">
                            <div class="col-md-4"><label class="mt-2 text-right">Tên khách hàng</label></div>
                            <div class="col-md-8">
                              <div class="mt-2">{{ dataCustomer.name }}</div>
                            </div>
                          </div>
                      </b-form-group>
                    </div>
                    <div class="col-md-6">
                      <b-form-group>
                        <div class="row">
                            <div class="col-md-4"><label class="mt-2 text-right">Số điện thoại</label></div>
                            <div class="col-md-8">
                              <div class="mt-2">{{dataCustomer.phoneNo}}</div>
                            </div>
                          </div>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <b-form-group>
                        <div class="row">
                          <div class="col-md-4">
                            <label class="mt-2 text-right">Nhóm khách</label>
                          </div>
                          <div class="col-md-8">
                            <div class="mt-2">{{dataCustomer.groups && dataCustomer.groups.length > 0 ? dataCustomer.groups[0].name : ""}}</div>
                          </div>
                        </div>
                        
                      </b-form-group>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <b-form-group>
                          <div class="row">
                            <div class="col-md-4">
                              <label class="mt-2 text-right">Phân loại</label>
                            </div>
                            <div class="col-md-8">
                              <div class="mt-2">{{dataCustomer.person ? "Cá nhân" : "Doanh nghiệp"}}</div>
                            </div>
                          </div>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <b-form-group>
                        <div class="row">
                          <div class="col-md-4">
                            <label class="mt-2 text-right">Email</label>
                          </div>
                          <div class="col-md-8">
                            <div class="mt-2">{{dataCustomer.email ? dataCustomer.email : ""}}</div>
                          </div>
                        </div>
                        
                      </b-form-group>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <b-form-group>
                          <div class="row">
                            <div class="col-md-4">
                              <label class="mt-2 text-right">Ngày sinh</label>
                            </div>
                            <div class="col-md-8">
                              <div class="mt-2" v-if="dataCustomer.birthday">
                                {{dataCustomer.birthday | formatDate}}
                              </div>
                            </div>
                          </div>
                        </b-form-group>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <b-form-group>
                        <div class="row">
                          <div class="col-md-4">
                            <label class="mt-2 text-right">Giới tính</label>
                          </div>
                          <div class="col-md-8">
                            <div class="mt-2">{{(dataCustomer.sex && dataCustomer.sex=='MALE') ? 'Nam' : "Nữ"}}</div>
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <b-form-group>
                          <div class="row">
                            <div class="col-md-4">
                              <label class="mt-2 text-right">Tỉnh /Thành phố</label>
                            </div>
                            <div class="col-md-8">
                              <div class="mt-2">
                                {{dataCustomer.cityValue}}
                              </div>
                            </div>
                          </div>
                        </b-form-group>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <b-form-group>
                        <div class="row">
                          <div class="col-md-4">
                            <label class="mt-2 text-right">Quận/ Huyện</label>
                          </div>
                          <div class="col-md-8">
                            <div class="mt-2">{{dataCustomer.districtValue}}</div>
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <b-form-group>
                          <div class="row">
                            <div class="col-md-4">
                              <label class="mt-2 text-right">Xã/ Phường</label>
                            </div>
                            <div class="col-md-8">
                              <div class="mt-2">
                                {{dataCustomer.wardValue}}
                              </div>
                            </div>
                          </div>
                        </b-form-group>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <b-form-group>
                          <div class="row">
                            <div class="col-md-2">
                              <label class="mt-2 text-right">Địa chỉ cụ thể</label>
                            </div>
                            <div class="col-md-10">
                              <div class="mt-2">{{ address ? address : "" }}</div>
                            </div>
                          </div>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </LayoutCard>
            <LayoutCard>
              <div class="box-title">Thông tin mua hàng</div>
              <div class="box-content">
                <div class="createStoreForm">
                  <div class="row">
                    <div class="col-md-6">
                      <b-form-group>
                        <div class="row">
                          <div class="col-md-4">
                            <label class="mt-2">Tổng chi tiêu</label>
                          </div>
                          <div class="col-md-8">
                            <div class="mt-2">{{formatMoneyNotUnitExt(totalAmountSuccessHistory)}}</div>
                          </div>
                        </div>
                        
                      </b-form-group>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <b-form-group>
                          <div class="row">
                            <div class="col-md-4">
                              <label class="mt-2">Tổng đơn</label>
                            </div>
                            <div class="col-md-8">
                              <div class="mt-2">{{totalElementsHistory}}</div>
                            </div>
                          </div>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </LayoutCard>
            <LayoutCard v-if="dataPermission && dataPermission.includes('NSH_ORDER_VIEW')">
              <div class="box-title">Lịch sử mua hàng</div>
              <div class="box-content-table w-100">
                <div class="mb-3">
                    <b-input-group class="wrapperInput">
                      <el-popover
                        placement="bottom-start"
                        width="500px"
                        trigger="click"
                        v-model="filterHistoryModal"
                      >
                      <div class="boxPopovers">
                        <div class="d-flex justify-content-between">
                          <multiselect
                              v-model="selectedStatusOrder"
                              :options="listStatusOrder"
                              deselectLabel=""
                              selectLabel=""
                              selectedLabel=""
                              placeholder="Trạng thái đơn"
                              label="text"
                              track-by="id"
                              class="mr-1"
                            >
                            </multiselect>

                            <multiselect
                              v-model="selectedLocation"
                              :options="listLocations"
                              deselectLabel=""
                              selectLabel=""
                              selectedLabel=""
                              placeholder="Chi nhánh"
                              label="name"
                              track-by="id"
                            >
                            </multiselect>
                        </div>
                        <div class="mt-2 clearfix">
                          <multiselect
                            v-model="selectedSource"
                            :options="listSource"
                            deselectLabel=""
                            selectLabel=""
                            selectedLabel=""
                            placeholder="Nguồn đơn"
                            label="text"
                            track-by="id"
                          >
                          </multiselect>
                        </div>
                        <div class="mt-2 clearfix">
                          <span class="col-4" style="position: relative; top: 10px;">Ngày ghi nhận:</span>
                          <el-date-picker
                            class="el col-8 pull-right"
                            type="daterange"
                            align="right"
                            start-placeholder="Từ ngày"
                            end-placeholder="Đến ngày"
                            format="dd/MM/yyyy"
                            v-model="dateRange"
                            :clearable="false">
                          </el-date-picker>
                        </div>
                        <div class="mt-2 clearfix text-right">
                          <BaseButton variant="outline" class="ml-3 b-primary pull-right" @click="getListHistory">Áp dụng bộ lọc</BaseButton>
                          <BaseButton variant="outline" class="ml-3 b-remove pull-right" @click="removeFilterHistory">Xóa bộ lọc</BaseButton>
                          <BaseButton variant="primary" class="ml-3 b-destroy pull-right" @click="filterHistoryModal = false">Huỷ</BaseButton>
                        </div>
                      </div>

                      <b-button slot="reference" class="btn btn-sm btn-filter mr-1">
                        <img src="@/assets/images/filter.svg">
                        Bộ lọc</b-button>
                      </el-popover>
                      <b-input-group-prepend>
                        <span class="input-group-text"><img src="@/assets/images/icon-search-box.svg"></span>
                      </b-input-group-prepend>
                      <b-form-input
                        v-model="filterHistory"
                        class="form-control f12 hc-37 textNameSearch"
                        placeholder="Tìm kiếm theo mã đơn hàng"
                      >
                      </b-form-input>
                      <div
                        v-if="this.filterHistory.length > 0"
                        class="removeText text-danger"
                        @click="removeHistory()"
                      >
                        ×
                      </div>
                    </b-input-group>
                  </div>

                <div class="createStoreForm">
                  <div class="mb-3">
                      <b-table
                      head-variant="light"
                      hover
                      :items="dataMoreHistory"
                      :fields="fieldsHistory"
                      :current-page="currentPage"
                      :per-page="perPage"
                      tbody-tr-class="row-table-class"
                      :filter="filterHistory"
                      :filter-included-fields="filterOn"
                      @filtered="onFiltered"
                      >

                      <template #table-caption v-if="dataMoreHistory.length == 0">
                        <div class="emptyData">
                          Khách chưa có đơn hàng nào
                        </div>
                      </template>

                      <template #cell(CODEHT)="data">
                        <p
                          class="pt-15 text-bold text-primary"
                          @click="orderDetail(data.item.id)"
                        >
                          {{ data.item.orderNo }}
                        </p>
                      </template>
                      <template #cell(STATUSHT)="data">
                        <StatusBox class="m-auto" :status="data.item.processorStatus"></StatusBox>
                      </template>
                      <template #cell(LOCATION)="data">
                        <p class="pt-15">
                          {{
                            data.item.locationToCreate
                              ? filterLocation(data.item.locationToCreate)
                              : "---"
                          }}
                        </p>
                      </template>
                      <template #cell(DATEHT)="data">{{
                        data.item.createdAt | formatDate
                      }}</template>
                      <template #cell(SOURCE)="data">{{
                        data.item.targetMethod | SourceOrder
                      }}</template>
                      <template #cell(PRICE)="data">{{
                        !data.item.lineItemFinalizing.finalAmount
                          ? 0
                          : divisionThousand(
                              data.item.lineItemFinalizing.finalAmount
                            ) | formatCurrency
                      }}</template>
                      </b-table>
                    </div>
                  <div class="row d-flex justify-content-end mr-3">
                    <div class="order-list-nav order-list-footer d-flex justify-content-end">
                      <b-pagination @change="changeCurrentPageHistory" v-model="currentPageHistory" :total-rows="totalElementsHistory" :per-page="searchOrder.pageSize" aria-controls="debt-table" hide-goto-end-buttons limit="5" last-text="next" align="right" />
                    </div>
                  </div>
                </div>
              </div>        
            </LayoutCard>
            <LayoutCard v-if="dataPermission && dataPermission.includes('NSH_DEBT_VIEW')">
              <div class="box-title">Sổ công nợ</div>
              <div class="box-content-table w-100">
                <base-expand-info :dataReport="dataReport"/>
                <div class="mb-3">
                    <b-input-group class="wrapperInput">
                      <el-popover
                        placement="bottom-start"
                        width="500px"
                        trigger="click"
                        v-model="filterDebitModal"
                      >
                        <div class="boxPopovers">
                          <div class="d-flex justify-content-between">
                            <multiselect
                            v-model="selectedType"
                            :options="listType"
                            deselectLabel=""
                            selectLabel=""
                            selectedLabel=""
                            placeholder="Loại khoản"
                            label="text"
                            track-by="id"
                            class="mr-2"
                          >
                          </multiselect>
                          <multiselect
                            v-model="selectedStatus"
                            :options="listStatus"
                            deselectLabel=""
                            selectLabel=""
                            selectedLabel=""
                            placeholder="Trạng thái"
                            label="text"
                            track-by="id"
                          >
                          </multiselect>
                          </div>
                          <div class="mt-2 clearfix">
                          <span class="col-4" style="position: relative; top: 10px;">Hạn trả:</span>
                          <el-date-picker
                            class="el col-8 pull-right"
                            type="daterange"
                            align="right"
                            start-placeholder="Từ ngày"
                            end-placeholder="Đến ngày"
                            format="dd/MM/yyyy"
                            v-model="dateRangeDebit"
                            :clearable="false">
                          </el-date-picker>
                        </div>
                        <div class="mt-2 clearfix text-right">
                          <BaseButton variant="outline" class="ml-3 b-primary pull-right" @click="getListDebt">Áp dụng bộ lọc</BaseButton>
                          <BaseButton variant="outline" class="ml-3 b-remove pull-right" @click="removeDebitHistory">Xóa bộ lọc</BaseButton>
                          <BaseButton variant="primary" class="ml-3 b-destroy pull-right" @click="filterDebitModal = false">Huỷ</BaseButton>
                        </div>
                        </div>

                        <b-button slot="reference" class="btn btn-sm btn-filter mr-1">
                          <img src="@/assets/images/filter.svg">
                          Bộ lọc
                        </b-button>
                      </el-popover> 

                      <b-input-group-prepend>
                        <span class="input-group-text"><img src="@/assets/images/icon-search-box.svg"></span>
                      </b-input-group-prepend>
                      <b-form-input
                        v-model="filterDebit"
                        class="form-control f12 hc-37 textNameSearch"
                        placeholder="Tìm kiếm theo tên khoản nợ"
                      >
                      </b-form-input>
                      <div
                        v-if="this.filterDebit.length > 0"
                        class="removeText text-danger"
                        @click="removeDebit()"
                      >
                        ×
                      </div>
                    </b-input-group>
                  </div>

                <div class="createStoreForm">
                  <div class="mb-3">
                      <b-table
                        head-variant="light"
                        hover
                        :items="dataMoreDebitNote"
                        :fields="fieldsDebtnote"
                        :current-page="currentPage"
                        :per-page="perPage"
                        tbody-tr-class="row-table-class"
                        :filter="filterDebit"
                        :filter-included-fields="filterOn"
                        @filtered="onFiltered"
                      >

                      <template #table-caption v-if="dataMoreDebitNote.length == 0">
                        <div class="emptyData">
                          Không có dữ liệu công nợ
                        </div>
                      </template>

                      <template #cell(TITLE)="data">
                        <p style="cursor: pointer" class="pt-15 text-bold text-primary" @click="debtDetail(data.item.id)">
                          {{ data.item.title }}
                        </p>
                      </template>
                      <template #cell(TYPE)="data">{{data.item.type | formatTypeDebt}}</template>
                      <template #cell(DATE)="data">{{data.item.dueAt | formatDate}}</template>
                      <template #cell(STATUS)="data">
                        <b-badge
                          pill
                          variant="secondary"
                          class="pt-15 p-2"
                          v-show="data.item.status == 'OPEN'"
                        >
                          Chưa thanh toán
                        </b-badge>
                        <b-badge
                          pill
                          variant="primary"
                          class="pt-15 p-2"
                          v-show="data.item.status == 'REPAYING'"
                        >
                          Thanh toán 1 phần
                        </b-badge>
                        <b-badge
                          pill
                          variant="primary"
                          class="pt-15 p-2"
                          v-show="data.item.status == 'SETTLED'"
                        >
                          Hoàn thành
                        </b-badge>
                        <b-badge
                          pill
                          variant="danger"
                          class="pt-15 p-2"
                          v-show="data.item.status == 'OVERDUE'"
                        >
                          Quá hạn
                        </b-badge>
                      </template>
                      <template #cell(DEBT)="data">
                        <p class="pt-15">
                          {{
                            divisionThousand(data.item.principal)
                              | formatCurrency
                          }}
                        </p>
                      </template>
                      <template #cell(PAID)="data">
                        <p
                          class="pt-15"
                          :class="
                            data.item.principal - data.item.balance > 0
                              ? 'text-success'
                              : ''
                          "
                        >
                          {{
                            divisionThousand(
                              data.item.principal - data.item.balance
                            ) | formatCurrency
                          }}
                        </p>
                      </template>
                      <template #cell(REMANIN)="data">
                        <p
                          class="pt-15"
                          :class="data.item.balance > 0 ? 'text-danger' : ''"
                        >
                          {{
                            divisionThousand(data.item.balance) | formatCurrency
                          }}
                        </p>
                      </template>

                      </b-table>
                    </div>
                </div>
              </div>    
            </LayoutCard>
            <LayoutCard>
              <div class="box-title">Thông tin liên hệ khác
                <span
                class="text-primary btn btn-info-ext pull-right font-size-14"
                type="button"
                v-show=" dataPermission && dataPermission.includes('NSH_PARTNER_CUS_UPDATE')" @click="clickAdd()"
                >Thêm mới liên hệ</span>
              </div>
              <div class="box-content-table w-100">
                <div class="createStoreForm">
                  <div class="mb-3">
                      <div class="row mb-3">
                        <div :class="selected.length > 0 ? 'col-lg-8' : 'col-lg-12'">
                          <b-input-group class="wrapperInput">
                            <b-input-group-prepend><span class="input-group-text"><img src="@/assets/images/icon-search-box.svg"></span></b-input-group-prepend>
                            <b-form-input
                              v-model="filter"
                              class="form-control f12 hc-37 textNameSearch"
                              placeholder="Tìm kiếm theo tên, sđt"
                            >
                            </b-form-input>
                            <div v-if="filter.length > 0" class="removeText text-danger" @click="remove()">×</div>
                          </b-input-group>
                        </div>

                        <div class="col-lg-4 text-right" v-if="selected.length > 0">
                          <span class="mt-2 mr-2">Đã chọn {{selected.length}} liên hệ</span>
                          <b-button variant="danger" @click="clickDeleteContactMore" class="btn-xs btn-danger-ext">Xóa</b-button>
                        </div>
                      </div>

                      <b-table
                      head-variant="light"
                      hover
                      :items="dataMoreContacts"
                      :fields="fieldsContact"
                      :current-page="currentPage"
                      :per-page="perPage"
                      tbody-tr-class="row-table-class"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      @filtered="onFiltered"
                      >

                      <template #table-caption v-if="dataMoreContacts.length == 0">
                        <div class="emptyData">
                          Chưa có thông tin liên hệ!<br/>
                          Thêm mới ngay để quản lý liên hệ của khách hàng.
                        </div>
                      </template>

                      <template v-slot:head(selected)>
                        <b-form-checkbox v-model="selectAll" />
                      </template>
                      <template #cell(selected)="data">
                        <b-form-checkbox
                          v-model="selected"
                          :value="data.item"
                        />
                    </template>

                      <template #cell(name)="data">
                        <span class="text-primary" v-if="dataPermission && dataPermission.includes('NSH_PARTNER_CUS_UPDATE')" @click="clickEdit(data.item)">
                          {{ data.item.name }}
                        </span>
                        <span v-else>{{ data.item.name }}</span>
                      </template>
                      <template #cell(phone)="data">
                        {{ data.item.phone }}
                      </template>
                      <template #cell(relationship)="data">
                        {{ data.item.rule }}
                      </template>
                      <template #cell(manipulation)="data">
                        <div class="text-center">
                          <span
                            v-if="
                              dataPermission &&
                              dataPermission.includes('NSH_PARTNER_CUS_UPDATE')
                            "
                            @click="clickDelete(data.item)"
                            class="btn-sm btn-ext"
                            ><i class="fa fa-close fz-15 color-red"></i
                          ></span>
                        </div>
                      </template>
                    </b-table>
                    </div>
                </div>
              </div>
            </LayoutCard>  
          </div>
        </div>
      </div>
      <div class="box-loading" v-if="loading">
        <div class="loading">
          <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
        </div>
      </div>
    </div>
    <NotPermission v-else></NotPermission>
  </TheLayout>
  <b-modal
    v-model="modalContact"
    centered
    hide-header
    hide-footer
    no-close-on-backdrop
  >
    <button
      @click="destroyModal()"
      type="button"
      aria-label="Close"
      class="close close-ext"
    >
      ×
    </button>
    <div v-if="adding" class="text-title-modal mb-3">Thêm mới liên hệ</div>
    <div v-else class="text-title-modal mb-3">Chỉnh sửa liên hệ</div>
    <validation-observer ref="observerPartner" v-slot="{ validate }">
      <RowWrapper>
        <template #center>
          <RowWrapper>
            <template #center>
              <b-form-group label="" label-for="formrow-groupname-input">
                <validation-provider
                  name="Tên liên hệ"
                  rules="required|lBetween:1,255|CHECK_HTML"
                  v-slot="{ errors, valid }"
                >
                  <label
                    >Tên liên hệ<sup class="text-danger"> * </sup></label
                  >
                  <b-form-input
                    id="formrow-groupname-input"
                    type="text"
                    placeholder="Nhập họ tên"
                    v-model="dataContact.name"
                    :state="errors[0] ? false : valid ? true : null"
                    @keydown.enter.prevent
                  />
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </validation-provider>
              </b-form-group>
            </template>
          </RowWrapper>

          <RowWrapper>
            <template #center>
              <b-form-group label="" label-for="formrow-phone-input">
                <validation-provider
                  name="Số điện thoại"
                  rules="PHONE_NO_3|CHECK_HTML|lBetween:1,15|required"
                  v-slot="{ errors, valid }"
                >
                  <label
                    >Số điện thoại<sup class="text-danger"> * </sup></label
                  >
                  <b-form-input
                    id="formrow-phone-input"
                    type="text"
                    placeholder="Nhập số điện thoại"
                    v-model.trim="dataContact.phone"
                    @keydown.enter.prevent
                    @keydown="allowNumbersOnly"
                    :state="errors[0] ? false : valid ? true : null"
                  />
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </validation-provider>
              </b-form-group>
            </template>
          </RowWrapper>
          <RowWrapper>
            <template #center>
              <b-form-group label="" label-for="formrow-rule-input">
                <validation-provider
                  name="Mối quan hệ với khách hàng"
                  rules="lBetween:0,255|CHECK_HTML"
                  v-slot="{ errors, valid }"
                >
                  <label>Mối quan hệ với khách hàng</label>
                  <b-form-input
                    v-model.trim="dataContact.rule"
                    id="formrow-rule-input"
                    class="form-control"
                    placeholder="Nhập mối quan hệ"
                    :state="
                      errors[0]
                        ? false
                        : valid &&
                          dataContact.rule != null &&
                          dataContact.rule != ''
                        ? true
                        : null
                    "
                  />
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </validation-provider>
              </b-form-group>
            </template>
          </RowWrapper>
        </template>
      </RowWrapper>
      <div>
        <div v-if="adding" class="mb-2 box-padd-15">
          <button
            class="btn btn-success pull-right"
            @click.prevent="saveItem(validate)"
          >
            Hoàn tất
          </button>
          <span  @click="destroyModal()" class="text-success-1 pull-right">Thoát</span>
        </div>
        <div v-else class="mb-2 box-padd-15">
          <button class="btn btn-danger" @click="clickDelete(dataContact)">
            Xóa
          </button>
          <button
            class="btn btn-success pull-right"
            @click.prevent="saveItem(validate)"
          >
            Lưu thay đổi
          </button>
          <span  @click="destroyModal()" class="text-success-1 pull-right">Thoát</span>
        </div>
      </div>
    </validation-observer>
  </b-modal>

  <b-modal
    v-model="modalDebt"
    centered
    hide-header
    hide-footer
    no-close-on-backdrop
  >
    <button
      @click="destroyModal()"
      type="button"
      aria-label="Close"
      class="close close-ext"
    >
      ×
    </button>
    <div class="text-title-modal mb-3">Thêm khoản nợ</div>
    <validation-observer ref="observerDebt" v-slot="{ validate }">
      <RowWrapper>
        <template #center>
          <RowWrapper>
            <template #center>
              <b-form-group label="" label-for="formrow-content-input">
                <validation-provider
                  name="Nội dung"
                  rules="required|lBetween:1,255|CHECK_HTML"
                  v-slot="{ errors, valid }"
                >
                  <label>Nội dung <sup class="text-danger"> * </sup></label>
                  <b-form-input
                    id="formrow-content-input"
                    type="text"
                    placeholder="Nhập nội dung"
                    v-model="dataDebt.content"
                    :state="errors[0] ? false : valid ? true : null"
                    @keydown.enter.prevent
                  />
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </validation-provider>
              </b-form-group>
            </template>
          </RowWrapper>

          <RowWrapper>
            <template #center>
              <b-form-group label="" label-for="formrow-content-input">
                <label for="input-typesOfDebt">
                  Loại công nợ <span style="color: red">*</span>
                </label>
                <Select2
                  placeholder="Chọn loại công nợ"
                  v-model="dataDebt.typesOfDebt"
                  :options="listType"
                />
              </b-form-group>
            </template>
          </RowWrapper>

          <RowWrapper>
            <template #center>
              <b-form-group label="" label-for="formrow-partner-input">
                <label>Gian dịch với</label>
                <b-form-input
                  id="formrow-partner-input"
                  readonly
                  :value="dataCustomer.name"
                />
              </b-form-group>
            </template>
          </RowWrapper>

          <RowWrapper>
            <template #center>
              <b-form-group label-for="formrow-content-input">
                <validation-provider
                  name="Tổng tiền"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label>
                    Tổng tiền <span style="color: red">*</span>
                  </label>
                  <b-input-group>
                    <b-form-input
                      id="formrow-content-input"
                      placeholder="0"
                      style="width: 80%"
                      v-model="dataDebt.total"
                      :state="errors[0] ? false : valid ? true : null"
                      @input="moneyTotalFormatter(dataDebt.total)"
                      @keydown="allowNumbersOnly"
                    />

                    <Select2
                      v-model="dataDebt.currency"
                      :options="units"
                      style="width: 20%"
                    />
                  </b-input-group>
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </validation-provider>
              </b-form-group>
            </template>
          </RowWrapper>

          <RowWrapper>
            <template #left-6>
              <b-form-group>
                <label> Ngày ghi nợ </label>
                <date-picker
                  v-model="startDebt"
                  type="date"
                  value-type="format"
                  placeholder="Thời gian từ"
                  :default-value="new Date().setHours(24, 0, 0, 0)"
                  @input="startDebt > endDebt ? (endDebt = startDebt) : ''"
                />
              </b-form-group>
            </template>

            <template #right-6>
              <b-form-group>
                <label>
                  Ngày hết hạn <span style="color: red">*</span></label
                >
                <date-picker
                  v-model="endDebt"
                  type="date"
                  value-type="format"
                  placeholder="Thời gian đến"
                  :default-value="new Date().setHours(24, 0, 0, 0)"
                  :disabled-date="
                    ($event) =>
                      startDebt
                        ? $event < new Date(startDebt + 'T00:00:00')
                        : false
                  "
                />
              </b-form-group>
            </template>
          </RowWrapper>

          <RowWrapper>
            <template #center>
              <b-form-group label-for="formrow-content-input">
                <validation-provider
                  name="Ghi chú"
                  rules="CHECK_HTML|max:500"
                  v-slot="{ errors, valid }"
                >
                  <label>Ghi chú</label>
                  <b-textarea
                    id="formrow-content-input"
                    type="text"
                    placeholder="Nhập ghi chú"
                    v-model="dataDebt.note"
                    :state="errors[0] ? false : valid ? true : null"
                    @keydown.enter.prevent
                  />
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </validation-provider>
              </b-form-group>
            </template>
          </RowWrapper>

          <div class="row">
            <div class="d-flex justify-content-between m-2 w-100">
              <button class="btn btn-danger">Hủy</button>
              <button
                class="btn btn-primary"
                @click.prevent="saveItemDebt(validate)"
              >
                Hoàn tất
              </button>
            </div>
          </div>
        </template>
      </RowWrapper>
    </validation-observer>
  </b-modal>

  <!--Xóa Item-->
  <el-dialog title="Xoá khách hàng" v-if="modalRemove" :visible.sync="modalRemove" id="modalRemove" width="500px"
    @close="modalRemove=false">
    <div class="line text-center">
      <div class="mt-2">
      <img src="@/assets/images/customer-nope-1.svg" />
      </div>
      <div class="mt-2">
        Bạn chắc chắn muốn xoá các khách hàng đã chọn ?</br>
        Thao tác này không thể khôi phục.
      </div>
    </div>
    <div class="line mt-4 bdt-btn-action">
      <div class="padd5">
        <button @click="confirmRemove" type="button" class="btn btn-default btn-red pull-right">Xác nhận xoá</button>  
        <button type="button" class="btn btn-default-ext text-primary pull-right" @click="modalRemove=false">Thoát</button>
      </div>
    </div>
  </el-dialog>

  <!--Xóa Item Contact-->
  <el-dialog title="Xoá thông tin liên hệ " v-if="modalRemoveContact" :visible.sync="modalRemoveContact" id="modalRemove" width="500px"
    @close="modalRemoveContact=false">
    <div class="line text-center">
      <div class="mt-2">
      <img src="@/assets/images/icon-contact.svg" />
      </div>
      <div class="mt-2">
        Bạn chắc chắn muốn xoá liên hệ  <span v-if="dataRemoveContact.name">“{{dataRemoveContact.name}}”</span>?</br>
        Thao tác này không thể khôi phục.
      </div>
    </div>
    <div class="line mt-4 bdt-btn-action">
      <div class="padd5">
        <button @click="confirmRemoveContact" type="button" class="btn btn-default btn-red pull-right">Xác nhận xoá</button>  
        <button type="button" class="btn btn-default-ext text-primary pull-right" @click="modalRemoveContact=false">Thoát</button>
      </div>
    </div>
  </el-dialog>
  <el-dialog title="Xoá thông tin liên hệ " v-if="modalRemoveContactMore" :visible.sync="modalRemoveContactMore" id="modalRemove" width="500px"
    @close="modalRemoveContactMore=false">
    <div class="line text-center">
      <div class="mt-2">
      <img src="@/assets/images/icon-contact.svg" />
      </div>
      <div class="mt-2">
        Bạn chắc chắn muốn xoá liên hệ ?</br>
        Thao tác này không thể khôi phục.
      </div>
    </div>
    <div class="line mt-4 bdt-btn-action">
      <div class="padd5">
        <button @click="confirmRemoveContactMore" type="button" class="btn btn-default btn-red pull-right">Xác nhận xoá</button>  
        <button type="button" class="btn btn-default-ext text-primary pull-right" @click="modalRemoveContactMore=false">Thoát</button>
      </div>
    </div>
  </el-dialog>
</div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import Swal from "sweetalert2";
import RowWrapper from "@/components/wrappers/RowWrapper";
import { CustomerServices } from "@/services/nextshop/customer.service";
import { DebtService } from "@/services/nextshop/debt.service";
import StatusBox from '@/components/status-box.vue';
import { authComputed } from "@/state/helpers";
import moment from "moment";
import baseExpandInfo from '@/components/base-expand-info.vue';
import VueCookies from 'vue-cookies'

export default {
  components: {
    RowWrapper,
    DatePicker,
    StatusBox,
    baseExpandInfo
  },
  data() {
    return {
      dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
      inforAccount: JSON.parse(localStorage.getItem("auth.currentUser")),
      loading: false,
      title: "CHI TIẾT KHÁCH HÀNG",
      filter: "",
      fields: [],
      fieldsContact: [
        {
          key: "selected",
          label: "",
          thStyle: { width: "1%" },
        },
        {
          key: "name",
          label: "Họ tên",
          thStyle: { width: "15%" },
        },
        {
          key: "phone",
          label: "Số điện thoại",
          thStyle: { width: "15%" },
        },
        {
          key: "relationship",
          label: "Mối quan hệ với khách hàng",
          thStyle: { width: "15%" },
        },
        {
          key: "manipulation",
          label: "",
          tdClass: "text-right",
          thStyle: { width: "3%" },
          thClass: "text-right",
        },
      ],
      fieldsDebtnote: [
        {
          key: "TITLE",
          label: "Tên khoản nợ",
          thStyle: { width: "8%" },
        },
        {
          key: "TYPE",
          label: "Loại khoản",
          thStyle: { width: "10%" },
        },
        {
          key: "DATE",
          label: "Hạn trả",
          thStyle: { width: "5%" },
        },
        {
          key: "STATUS",
          label: "Trạng thái",
          thStyle: { width: "5%" },
        },
        {
          key: "DEBT",
          label: "Nợ gốc",
          thStyle: { width: "5%" },
          thClass: "text-right",
          tdClass: "text-right",
        },
        {
          key: "PAID",
          label: "Đã thanh toán",
          thStyle: { width: "10%" },
          thClass: "text-right",
          tdClass: "text-right",
        },
        {
          key: "REMANIN",
          label: "Còn lại",
          thStyle: { width: "5%" },
          thClass: "text-right",
          tdClass: "text-right",
        },
      ],
      fieldsHistory: [
        {
          key: "CODEHT",
          label: "Mã đơn hàng",
          thStyle: { width: "5%" },
        },
        {
          key: "STATUSHT",
          label: "Trạng thái",
          thStyle: { width: "8%" },
          thClass: "text-center",
        },
        {
          key: "LOCATION",
          label: "Chi nhánh",
          thStyle: { width: "5%" },
        },
        {
          key: "DATEHT",
          label: "Ngày ghi nhận",
          thStyle: { width: "5%" },
        },
        {
          key: "SOURCE",
          label: "Kênh bán",
          thStyle: { width: "5%" },
        },
        {
          key: "PRICE",
          label: "Giá trị đơn hàng",
          thStyle: { width: "5%" },
          thClass: "text-right",
          tdClass: "text-right",
        },
      ],
      filterOn: [],
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      dataCustomer: [],
      dataMore: [],
      dataReport: [
      {
          text: "Phải thu của khách",
          value: 0
        },
        {
          text: "Phải trả cho khách",
          value: 0
        }
      ],
     
      dataContact: {},
      modalContact: false,
      adding: true,
      addressInfor: [],
      address: "",

      modalDebt: false,
      dataDebt: {
        typesOfDebt: "lending",
        currency: "VND",
      },
      selectedType: null,
      selectedStatus: null,
      selectedDate: "",
      dateEnd: "",

      listType: [
        { id: "ALL", text: "Tất cả" },
        { id: "lending", text: "Khoản phải thu" },
        { id: "borrowing", text: "Khoản phải trả" },
      ],
      listStatus: [
        { id: "ALL", text: "Tất cả" },
        { id: "OPEN", text: "Chưa thanh toán" },
        { id: "REPAYING", text: "Thanh toán 1 phần" },
        { id: "OVERDUE", text: "Quá hạn" },
      ],
      
      selectedStatusOrder: null,
      selectedLocation: null,
      selectedSource: null,
      listStatusOrder: [
        { id: "ALL", text: "Tất cả" },
        { id: "COMPLETE", text: "Hoàn thành" },
        { id: "NEW", text: "Đang xử lí" },
        { id: "CANCEL", text: "Đã hủy" },
      ],
      units: [{ id: "VND", text: "VNĐ" }],
      startDebt: "",
      endDebt: moment().format("YYYY-MM-DD"),
      searchOrderTmp: [],
      searchOrder: {
        "queryString": "",
        "sort": "DESC",
        "sortBy" : "createdAt",
        "pageSize": 30,
        "pageNum": 1
      },
      totalElementsHistory: 0,
      currentPageHistory: 1,
      totalAmountSuccessHistory: 0,
      searchDebtTmp: {},
      searchDebt: {
        queryString: {},
        pagingAndSorting: { limit: 100, lastIndex: "", sortOrder: 1 },
      },
      lang: {
        formatLocale: {
          monthsShort: [
            "Tháng 1",
            "Tháng 2",
            "Tháng 3",
            "Tháng 4",
            "Tháng 5",
            "Tháng 6",
            "Tháng 7",
            "Tháng 8",
            "Tháng 9",
            "Tháng 10",
            "Tháng 11",
            "Tháng 12",
          ],
          weekdaysMin: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
        },
      },
      listSource: [
        { id: "ALL", text: "Tất cả" },
        {
          id: "NEXT_SHOP_POS_APP",
          text: "Nextshop App",
        },
        {
          id: "NEXT_SHOP_POS_WEB",
          text: "Bán tại cửa hàng",
        },
        {
          id: "ONLINE_STORE",
          text: "Gian hàng trực tuyến",
        },
      ],
      selected: [],
      dataMoreContacts: [],
      dataMoreHistory: [],
      dataMoreDebitNote:[],
      filterHistory: '',
      filterDebit: '',
      filterHistoryModal: false,
      dateRange: [],
      filterDebitModal: false,
      dateRangeDebit: [],
      modalRemove: false,
      dataRemove: {},
      modalRemoveContact: false,
      dataRemoveContact: {},
      modalRemoveContactMore: false,
      totalLending: 0,
      MID: VueCookies.get("MID")
    };
  },
  async created() {
    await this.fetchData();
    await this.getListHistory();
    await this.getListDebt();
    await this.handleAddress();
    await this.getTotallDebit();
  },
  methods: {
    allowNumbersOnly($event) {
      if (
        !["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].includes(
          $event.key
        ) &&
        $event.keyCode !== 8
      ) {
        $event.preventDefault();
      }
    },
    editItem() {
      this.$router.push({
        path: `/customer-list/customer-edit/${this.$route.params.id}`,
      });
    },
    remove() {
      this.filter = "";
    },
    removeDebit() {
      this.filterDebit = "";
    },
    removeHistory(){
      this.filterHistory = "";
    },
    async fetchData() {
      this.loading = true;
      try {
        this.dataMoreContacts = [];
        const response = await CustomerServices.getCustomerById({
          merchantId: this.inforAccount.merchantId,
          query: this.$route.params.id,
        });
        if (response.success) {
          this.dataCustomer = response.data;
          this.dataMoreContacts = response.data.contacts;
          this.dataMoreContacts.id = response.data.contacts.map((e) => {
            e.id = Math.floor(Math.random() * 10000000);
          });
          this.loading = false;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    deleteItem(data) {
      this.modalRemove = true
      this.dataRemove = data
    },
    async confirmRemove() {
      this.modalRemove = false
      this.loading = true;
      const item_id = this.dataRemove.id
      try {
        const response = await CustomerServices.deleteCustomer({
          merchantId: this.inforAccount.merchantId,
          partnerIds: [item_id],
        });
        if (response.success) {
          this.$router.push({ path: `/customer-list` });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    clickAdd() {
      this.adding = true;
      this.dataContact = {};
      this.modalContact = true;
    },
    clickEdit(data) {
      this.adding = false;
      this.dataContact = {
        id: data.id,
        name: data.name,
        phone: data.phone,
        rule: data.rule,
      };
      this.modalContact = true;
    },
    clickDelete(data) {
      this.modalRemoveContact = true
      this.dataRemoveContact = data
      this.modalContact = false
    },
    async confirmRemoveContact(){
      const item_id = this.dataRemoveContact.id
      const index = this.dataMoreContacts.findIndex((e) => {return e.id === item_id;});
      this.dataMoreContacts.splice(index, 1);
      this.loading = true;
      try {
        const response = await CustomerServices.contact({
          id: this.dataCustomer.id,
          contacts: this.dataMoreContacts,
          version: this.dataCustomer.version,
        });
        if (response.success) {
          this.loading = false;
          this.fetchData();
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
      this.modalRemoveContact = false
    },
    clickDeleteContactMore(){
      this.modalRemoveContactMore = true
    },
    async confirmRemoveContactMore(){
     if(this.selected.length > 0){
      this.loading = true;
      this.selected.map((e)=>{
        const item_id = e.id
        const index = this.dataMoreContacts.findIndex((e) => {return e.id === item_id;});
        this.dataMoreContacts.splice(index, 1);
      })
      try {
        const response = await CustomerServices.contact({
          id: this.dataCustomer.id,
          contacts: this.dataMoreContacts,
          version: this.dataCustomer.version,
        });
        if (response.success) {
          this.loading = false;
          this.modalRemoveContactMore = false
          this.selected = []
          this.fetchData();
        }
      } catch (error) {
        this.loading = false;
        this.modalRemoveContactMore = false
        console.log(error);
      }
     }
    },

    destroyModal() {
      this.modalContact = false;
      this.modalDebt = false;
    },
    successmsg() {
      let _title = ''
      if(this.adding){
        _title = 'Thêm mới thành công!'
      }else{
        _title = 'Cập nhật thành công!'
      }

      this.$bvToast.toast(_title, {
        title: `Thông báo`,
        autoHideDelay: `1000`,
        variant: `success`,
        toaster: `b-toaster-top-right`,
        solid: true,
        appendToast: true,
      });
      this.fetchData();
    },
    deletemsgcontact() {
      Swal.fire({
        title: "Thành công",
        text: this.adding
          ? "Đã tạo mới liên hệ thành công!"
          : "Đã cập nhật thông tin thành công!",
        icon: "success",
        confirmButtonText: "Tiếp tục",
      }).then((result) => {
        if (result.value) {
          this.fetchData();
        }
      });
    },
    async saveItem(validate) {
      validate().then(async (success) => {
        if (!success) {
          const el = document.querySelector(".is-invalid");
          el.focus();
          return;
        } else {
          if (this.adding) {
            this.dataMoreContacts.push(this.dataContact);
          }
          {
            const index = this.dataMoreContacts.findIndex((e) => {
              return e.id === this.dataContact.id;
            });
            if (index !== -1) {
              this.dataMoreContacts.splice(index, 1, this.dataContact);
            }
          }

          this.loading = true;
          try {
            const response = await CustomerServices.contact({
              id: this.dataCustomer.id,
              contacts: this.dataMoreContacts,
              version: this.dataCustomer.version,
            });
            if (response.success) {
              this.loading = false;
              this.successmsg();
            }
            this.destroyModal();
          } catch (error) {
            this.loading = false;
            console.log(error);
          } finally {
            this.loading = false;
          }
        }
      });
    },
    async saveItemDebt(validate) {
      validate().then(async (success) => {
        if (!success) {
          const el = document.querySelector(".is-invalid");
          el.focus();
          return;
        } else {
          try {
            this.loading = true
            const dateTo = this.startDebt ? new Date(this.startDebt) : null;
            const dateFrom = new Date(this.endDebt + " 23:59:59 UTC");
            const params = {
              currency: "VND",
              dueAt: dateFrom.toISOString(),
              startAt: dateTo ? dateTo.toISOString() : null,
              note: this.dataDebt.note ? this.dataDebt.note : null,
              principal: this.multiplicationThousand(
                parseInt(this.dataDebt.total.replace(/,/g, ""))
              ),
              title: this.dataDebt.content.trim(),
              type: this.dataDebt.typesOfDebt,
              partner: {
                partnerDisplayName: this.dataCustomer.name,
                partnerId: this.dataCustomer.id,
              },
            };

            const response = await DebtService.addNewDebt(params);
            if (response.success) {
              this.modalDebt = false;
              Swal.fire({
                title: "Thành công",
                text: `Đã cập nhật thông tin thành công`,
                icon: "success",
                confirmButtonText: "Xác nhận",
              }).then((result) => {
                if (result.value) {
                  this.getListDebt();
                }
              });
            }
          } catch (error) {
            console.log(error);
          } finally {
            this.loading = false
          }
        }
      });
    },
    handleAddress() {
      this.dataCustomer.address
        ? this.addressInfor.push(this.dataCustomer.address)
        : "";
      this.addressInfor.reverse();
      return (this.address = this.addressInfor.join("," + " "));
    },
    
    addDebt() {
      this.modalDebt = true;
      this.dataDebt = {
        typesOfDebt: "lending",
        currency: "VND",
      };
    },
    
    moneyTotalFormatter(val) {
      if (val == 0) {
        val = "";
      }
      val = val.toString().split(",").join("");
      this.$emit("input", val);

      let output = "";
      while (val.length >= 3) {
        const last3Digits = val.slice(val.length - 3, val.length);
        val = val.slice(0, val.length - 3);
        output = "," + last3Digits + output;
      }
      if (val.length === 0) {
        output = output.slice(1, output.length);
      } else {
        output = val + output;
      }
      this.dataDebt.total = output;
    },

    async getListDebt() {
      try {
        this.loading = true
        this.dataMoreDebitNote = [];
        this.searchDebtTmp = {
          "partner.partnerId": { like: this.dataCustomer.id },
        };
        if (this.selectedStatus && this.selectedStatus.id !== "ALL") {
          this.searchDebtTmp.status = { eq: this.selectedStatus.id };
        }

        if (this.dateRangeDebit.length > 0) {
          this.searchDebtTmp.dueAt = {
            range: {
              gte: moment(this.dateRangeDebit[0])
                .hours(0)
                .minutes(0)
                .seconds(0)
                .milliseconds(0)
                .format(),
              lte: moment(this.dateRangeDebit[1])
                .hours(23)
                .minutes(59)
                .seconds(59)
                .milliseconds(0)
                .format()
            },
          };
        }

        if (this.selectedType && this.selectedType.id !== "ALL") {
          this.searchDebtTmp.type = { eq: this.selectedType.id };
        }
        this.searchDebt.queryString = this.searchDebtTmp;
        const response = await DebtService.searchDebt(this.searchDebt);
        if (response.success) {
          this.dataMoreDebitNote = response.data;
          this.totalRows = this.dataMoreDebitNote.length;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false
      }
    },
    debtDetail(id) {
      this.$router.push({ path: `/debt_detail/${id}` });
    },
    orderDetail(id) {
      this.$router.push({ path: `/pos/pos-detail/${id}` });
    },
    filterLocation(val) {
      const name = this.currentUser.locationInfos.filter((e) => {
        return e.id == val;
      });
      return name[0].name;
    },
    removeFilterHistory(){
      this.selectedStatusOrder = null
      this.selectedLocation = null
      this.selectedSource = null
      this.dateRange = []
    },
    removeDebitHistory(){
      this.selectedType = null
      this.selectedStatus = null
      this.dateRangeDebit = []
    },
    async getListHistory() {
      try {
        this.loading = true
        this.dataMoreHistory = [];
        
        this.searchOrderTmp = ["{partyB.resId} == '''"+this.$route.params.id+"''' and {orderType} == '''SO'''"];
        
        if (this.selectedStatusOrder && this.selectedStatusOrder.id !== "ALL") {
          switch (this.selectedStatusOrder.id) {
            case "COMPLETE":
              this.searchOrderTmp.push("{processorStatus} == '''COMPLETE'''");
              break;
            case "NEW":
              this.searchOrderTmp.push(
                "({processorStatus} == '''NEW''' or {processorStatus} == '''PROCESSING''')"
              );
              break;
            case "CANCEL":
              this.searchOrderTmp.push(
                "({processorStatus} == '''TIMEOUT''' or {processorStatus} == '''CANCEL''')"
              );
              break;
          }
        }
        
        if (this.selectedLocation && this.selectedLocation.id !== "ALL") {
          this.searchOrderTmp.push(
            "{locationToCreate} == '''" + this.selectedLocation.id + "'''"
          );
        }
        if (this.filterHistory) {
          this.searchOrderTmp.push(
            "{orderNo} == '''" + this.filterHistory.trim() + "'''"
          );
        }
        
        if (this.dateRange.length > 0) {
          this.searchOrderTmp.push(
            "{createdAt} >= #" +
              moment(this.dateRange[0]).format('YYYY-MM-DD') +
              "T00:00:00.00+07:00# and {createdAt} <= #" +
                moment(this.dateRange[1]).format('YYYY-MM-DD') +
              "T23:59:59.00+07:00#"
          );
        }
        
        if (this.selectedSource && this.selectedSource.id !== "ALL") {
          switch (this.selectedSource.id) {
            case "NEXT_SHOP_POS_APP":
              this.searchOrderTmp.push(
                "{targetMethod} == '''NEXT_SHOP_POS_APP'''"
              );
              break;
            case "NEXT_SHOP_POS_WEB":
              this.searchOrderTmp.push(
                "({targetMethod} == '''NEXT_SHOP_POS_WEB''' or {targetMethod} == '''NEXT_SHOP_POS_WEB_ENABLE_DRAFT''')"
              );
              break;
            case "ONLINE_STORE":
              this.searchOrderTmp.push("{targetMethod} == '''ONLINE_STORE'''");
              break;
          }
        }

        if (this.searchOrderTmp.length) {
          this.searchOrder.queryString = this.searchOrderTmp.join(" and ");
        }

        const response = await CustomerServices.getDetailHistoryBuy(this.searchOrder);
        if (response.success) {
          if(response.data.orders.length > 0){
            this.dataMoreHistory = response.data.orders;
            this.totalPageHistory = response.data.totalPage
            this.totalElementsHistory = response.data.totalElements
            this.totalAmountSuccessHistory = this.divisionThousand(response.data.totalAmountSuccess)
          }
          this.loading = false
        }
      } catch (error) {
        console.log(error);
        this.loading = false
      }
    },
    changeCurrentPageHistory(page){
      this.currentPageHistory = page
      this.searchOrder.pageNum = page;
      this.getListHistory();
    },
    async getTotallDebit(){
      const merchantId = this.inforAccount.merchantId
      const partnerId = this.dataCustomer.id
      const response = await CustomerServices.getTotallDebit(merchantId, partnerId)
      if(response.success){
        this.totalLending = (response.data.lending) ? this.divisionThousand(response.data.lending.totalAmount - response.data.lending.paidAmount) : 0
        this.totalBorrowing = (response.data.borrowing) ? this.divisionThousand(response.data.borrowing.totalAmount - response.data.borrowing.paidAmount) : 0
        this.dataReport[0].value = this.formatMoneyNotUnit(this.totalLending)
        this.dataReport[1].value = this.formatMoneyNotUnit(this.totalBorrowing)
      }
    }
  },
  computed: {
    ...authComputed,
    rows() {
      return this.dataContact.length;
    },
    listLocations() {
      let location = [{ id: "ALL", name: "Tất cả" }];
      this.currentUser.locationInfos.filter((e) => {
        location.push({ id: e.id, name: e.name });
      });
      return location;
    },
    selectAll: {
      get: function () {
        return this.dataCustomer.length
          ? this.selected.length == this.dataCustomer.length
          : false;
      },
      set: function (value) {
        let selected = [];
        if (value) {
          this.dataMoreContacts.forEach(function (val) {
            selected.push(val);
          });
          this.selected = selected;
          
        } else {
          if (this.selected.length == this.dataMoreContacts.length) {
            this.selected = [];
          }
        }
        this.selected = selected;
      },
    }
  }
};
</script>
<style lang="scss" scoped>
.invalid-feedback {
  display: block;
}
#page-topbar {
  z-index: 10;
  .navbar-header {
    padding: 10px 20px;
    .headerPage {
      height: 80px;
      padding: 24px;
      &-title {
        p {
          font-weight: 600;
          font-size: 22px;
          line-height: 125%;
          margin: 0;
          color: #23313e;
        }
      }
      &-button {
        display: inline-block;
        .__secondary {
          float: left;
        }
        button {
          margin: 0 5px;
        }
      }
    }
  }
}
.layout-content {
  margin: 110px auto 60px;
}
.box-title{
  font-size: 18px;
  font-weight: bold;
  display: inline-block;
  width: 100%;
  color: #141C23;
}
.box-content {
  display: inline-block;
  width: 100%;
}
.text-mess {
  border: 1px solid #FFC043;
  padding: 8px 10px;
  border-radius: 5px;
  background: #FFF9EC;
}
.boxImg{
  margin-top: 35px;
  display: inline-block;
  width: 100%;
}
.box-upload-img {
  border: 2px dashed #ced4da;
  width: 100%;
  border-radius: 5px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  font-size: 24px;
  color: #ced4da;
  cursor: pointer;
  margin-bottom: 15px;
  overflow: hidden;
  position: relative;
}
.box-upload-img img{
  max-height: 100%;
}
input[type="file"] {
  display: none;
}
.box-upload-img .icon-remove{
  position: absolute;
  right: 5px;
  top: 1px;
  color: #DC2323;
  background: #FCE7EB;
  font-size: 15px;
  border-radius: 100%;
  z-index: 5;
  width: 20px;
  height: 20px;
  line-height: 20px;
}
.box-upload-img .icon-remove:hover{
  background: #ddd;
}
.capitalize{
  text-transform: capitalize;
}
.text-red{
  word-break: break-word;
}
.btn-danger-ext{
  background: #FEF3F5!important;
  border-color: #FEF3F5!important;
  color: #DC2323!important;
  font-size: 14px!important;
}
.btn-info-ext{
  background: #ECF0FE!important;
  color:#3E69F6!important;
  border: 1px solid #ECF0FE!important;
}
.box-content-table{
  margin-top: 15px!important;
}
.btn.btn-filter {
  background: #eff2f7 !important;
  border: 1px solid #eff2f7;
  color: #23313E !important;
  display: inline-block;
  padding: 5px 10px!important;
}
.wrapperInput .form-control {
  height: calc( 1.5em + 0.94rem + 3px );
}
.boxPopovers{
  width: 400px;
}
.b-primary{
  background: #3E69F6!important;
  color: #fff!important;
}
.b-remove{
  background: #fff!important;
  color: #DC2323!important;
  border: 1px solid #F8B6C2!important;
}
.b-destroy{
  color: #23313E!important;
  background: #fff!important;
  border: 1px solid #DDDDDD!important;
}
.emptyData {
  text-align: center;
  padding: 30px 0;
}
::v-deep #modalRemove .el-dialog__body {
  padding: 20px 0px 15px;
  display: inline-block;
  width: 100%;
}
.btn-default-ext{
  background: none!important;
  color: #3E69F6!important;
}
.b-primary{
  background: #3E69F6!important;
  color: #fff!important;
}
.b-remove{
  background: #fff!important;
  color: #DC2323!important;
  border: 1px solid #F8B6C2!important;
}
.b-destroy{
  color: #23313E!important;
  background: #fff!important;
  border: 1px solid #DDDDDD!important;
}
label{
  width: 100%;
  color: #9093A4 ;
}
.btn-default-edit{
  background: #fff !important;
  border: 1px solid #DDD !important;
  color: #23313E !important;
}
::v-deep .modal-content .modal-body {
  padding: 0px !important;
}
::v-deep .modal-content label{
  color: #23313E;
}
::v-deep .modal-content .btn-success{
  background: #3E69F6!important;
  border: 1px solid #3E69F6!important;
}
::v-deep .modal-content .text-title-modal {
  color: #3c3e49;
  font-size: 20px;
  text-transform: none;
  background: #F1F1F1;
  padding: 12px 10px;
}
::v-deep .modal-content .form-group {
  padding: 0 12px;
}
::v-deep .modal-content .close.close-ext {
  position: relative;
  top: 8px;
  right: 10px;
}
::v-deep .modal-content .box-padd-15 {
  padding: 15px 10px 0;
  border-top: 1px solid #ddd;
  display: inline-block;
  width: 100%;
}
::v-deep  #modalRemove .el-dialog__header {
  padding-bottom: 10px;
  padding-top: 12px;
}
::v-deep  #modalRemove .el-dialog__headerbtn {
  top: 12px;
}
.text-success-1{
  color:#3E69F6;
  margin-top: 10px;
  margin-right: 10px;
  cursor: pointer;
}
.font-size-14{
  font-size: 14px!important;
}
.input-group-text{
  background: none!important;
  border-right: none!important;
}
.textNameSearch{
  border-left: none!important;
  padding-left: 0px!important;
}
::v-deep .fa-search{
  color: #7c7e93 !important;
}
</style>
